import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useDeleteDeveloperWebhookEndpointMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.deleteWebhookEndpoint(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.webhookEndpoint() }), i.invalidateQueries({ queryKey: e.deliveries() }), i.invalidateQueries({ queryKey: e.deliveryStats() });
		}
	});
};
//#endregion
export { i as useDeleteDeveloperWebhookEndpointMutation };
